<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>翻拍识别</el-breadcrumb-item>
        <el-breadcrumb-item>
          <router-link :to="`/order-image-recapture-detection/summary-customer-table`">{{$route.meta.title}}</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{customer.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="项目名称"
                        prop="keyword">
            <el-input placeholder="请输入项目名称"
                      clearable
                      v-model="search.keyword" />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="project_number"
                         label="项目编号" />
        <el-table-column prop="project_name"
                         label="项目名称">
          <template slot-scope="scope">
            <router-link :to="`/order-image-recapture-detection/summary-batch-table?customerid=${search.customerid}&projectid=${scope.row.projectid}`">{{scope.row.project_name}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="total_cnt"
                         label="总数">
          <template slot-scope="scope">
            <router-link :to="`/order-image-recapture-detection/image-table?customerid=${search.customerid}&projectid=${scope.row.projectid}`">{{scope.row.total_cnt}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="suspect_cnt"
                         label="疑似翻拍">
          <template slot-scope="scope">
            <router-link :to="`/order-image-recapture-detection/image-table?customerid=${search.customerid}&projectid=${scope.row.projectid}&result=2`">{{scope.row.suspect_cnt}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="original_cnt"
                         label="非翻拍">
          <template slot-scope="scope">
            <router-link :to="`/order-image-recapture-detection/image-table?customerid=${search.customerid}&projectid=${scope.row.projectid}&result=3`">{{scope.row.original_cnt}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="recaptured_cnt"
                         label="确认翻拍">
          <template slot-scope="scope">
            <router-link :to="`/order-image-recapture-detection/image-table?customerid=${search.customerid}&projectid=${scope.row.projectid}&result=4`">{{scope.row.recaptured_cnt}}</router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      search: {
        customerid: this.$route.query.customerid,
        keyword: null,
      },
      customer: {
        name: null,
      }
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOrderImageRecaptureDetectionProjectSummaryTable', params).then((data) => {
        this.customer = data.data.customer
        return new Promise((resolve) => resolve(data))
      })
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportOrderImageRecaptureDetectionData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteOrderImageRecaptureDetectionData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/order-image-recapture-detection/pages/OrderImageRecaptureDetectionSummaryProjectTable.vue